import { render, staticRenderFns } from "./TopKCarousel.vue?vue&type=template&id=456585f4&scoped=true"
import script from "./TopKCarousel.vue?vue&type=script&lang=js"
export * from "./TopKCarousel.vue?vue&type=script&lang=js"
import style0 from "./TopKCarousel.vue?vue&type=style&index=0&id=456585f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456585f4",
  null
  
)

export default component.exports